import LayoutBase from '~/themes/base/components/shop/LayoutBase'

export default {
  extends: LayoutBase,
  props: {
    background: Boolean,
  },
  computed: {
    showTopBanner() {
      const { domain, topBanner } = this.$store.state.globals
      const enabledDomains = topBanner?.domain_enabled || []

      return topBanner && topBanner.enabled && (!enabledDomains.length || enabledDomains.includes(domain.code))
    },
  },
}
